import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Phone } from "lucide-react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import { Seo } from "./components/Seo";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import RequestQuote from "./pages/RequestQuote";
import RequestReceived from "./pages/RequestReceived";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Services from "./pages/Services";
import { PHONE_HREF } from "./lib/site";
import { SERVICES } from "./lib/services";

const MobileBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-[auto_1fr] gap-2 border-t border-white/10 bg-ink/90 p-3 backdrop-blur-xl md:hidden" data-testid="mobile-cta-bar">
    <a href={PHONE_HREF} data-testid="mobile-bar-call" aria-label="Call Shine Solutions" className="flex items-center justify-center rounded-full border border-white/20 px-5 text-white"><Phone className="h-4 w-4" /></a>
    <Link to="/request-quote" data-testid="mobile-bar-quote" className="rounded-full bg-glint py-3.5 text-center text-sm font-semibold text-ink">Request a Free Cleaning Quote</Link>
  </div>
);

const NotFound = () => (
  <section className="flex min-h-[70vh] items-center bg-ink px-5 pt-32 text-white md:px-10">
    <Seo title="Page not found | Shine Solutions" description="The page you requested could not be found." />
    <div className="mx-auto w-full max-w-[1400px]">
      <h1 className="font-display text-6xl font-semibold">Page not found.</h1>
      <Link to="/" data-testid="notfound-home-link" className="btn-glint mt-10">Back to home</Link>
    </div>
  </section>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            {SERVICES.map((s) => <Route key={s.slug} path={s.path} element={<ServicePage slug={s.slug} />} />)}
            <Route path="/request-quote" element={<RequestQuote />} />
            <Route path="/request-received" element={<RequestReceived />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <MobileBar />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
